import type { ResolvedPageContext } from '../contracts'
import { getHostRuntime } from '../host-runtime'

export type { ResolvedPageContext }

export interface PageContext {
  dataClassName: string
  entityId: string
}

let _currentPageContext: PageContext | null = null

export function setCurrentPageContext(ctx: PageContext | null): void {
  _currentPageContext = ctx
}

function getCurrentPageContext(): PageContext | null {
  return _currentPageContext
}

export function resolvePageContext(): ResolvedPageContext {
  const ctx = getCurrentPageContext()
  if (ctx) {
    return { mode: 'detail', dataClass: ctx.dataClassName, id: ctx.entityId }
  }
  return (
    getHostRuntime().resolvePageFromUrl?.() ?? {
      mode: 'dashboard',
      dataClass: null,
      id: null,
    }
  )
}
